import moment from 'moment';
import Link from 'components/mainMenu/link';
import { STATES } from 'common/domain/states';
import { EVENTS, PAGE_ERROR } from 'common/domain/constants';

class FoodBenefitRoutingController {

  constructor
  (
    $scope,
    $state,
    $window,
    FoodBenefitUserDataService,
    foodBenefitService,
    foodDelegationService,
    ManagerNavigationService,
    HelperDelegationsService,
    metricsService
  )
  {
    'ngInject';
    this.state = $state;
    this.scope = $scope;

    this.foodBenefitUserDataService = FoodBenefitUserDataService;
    this.foodBenefitService = foodBenefitService;
    this.foodDelegationService = foodDelegationService;
    this.ManagerNavigationService = ManagerNavigationService;
    this.helperDelegations = HelperDelegationsService;
    this.metricsService = metricsService;

    this.isMobileApp = $window.innerWidth < 1024;

    this.isLoaded = false;
    this.hasAlert = false;

    this.scope.$on(EVENTS.ICON_DELEGATIONS, () => {
      this._initData();
    });
  }

  $onInit() {
    if (this.isModuleClosed()) {
      return;
    }

    this.foodBenefitService.loadData();

    this.metricsService.init();

    this.scope.$watch(() => this.foodBenefitService.loaded, (newValue) => {
      if (newValue) {
        this.isLoaded = true;
        this.employee = this.foodBenefitUserDataService.getEmployee();
        this.manager = this.foodBenefitService.ManagerDataService._manager;
        this.userId = this.employee.userId;
        this.employeeopplus = this.employee._profile.employeeopplus;
        this.isManager = this.employee._profile.role() === 'manager';
        this._initData();
        this.hasElevatedRights = this.employee.hasManagerDelegation() || this.employee.isManager();
        this.ManagerNavigationService.canNavigateToState(this.hasElevatedRights);
      }
    });
  }

  _initData() {
    this._checkDelegations().then(() => {
      this._initLinks();
    });
  }

  _initLinks() {
    this.links = [];
    this.links.push(new Link('MI AYUDA ALIMENTARIA', 'MI AYUDA ALIMENTARIA', STATES.FOOD_BENEFIT.MY_FOOD_BENEFIT, ''));
    if (this.hasElevatedRights) {
      //this.links.push(new Link('SOLICITUDES DE EQUIPO', 'SOLICITUDES DE EQUIPO', STATES.FOOD_BENEFIT.TEAM_REQUESTS, ''));
      this.links.push(new Link('MIS COLABORADORES', 'MIS COLABORADORES', STATES.FOOD_BENEFIT.WORK_TEAM, ''));
    }

    let delegationLink = new Link('DELEGACIÓN PERMISO', 'DELEGACIÓN PERMISO', STATES.FOOD_BENEFIT.DELEGATE, '');
    if (this.hasAlert) {
      delegationLink.setAlertIcon('icon-warning');
    }

    this.links.push(delegationLink);
  }

  _checkDelegations() {
    const today = moment().format('YYYY-MM-DD');
    return this.foodDelegationService.getDelegations(this.userId).then((delegations) => {
      this.delegationsObject = delegations;
      let delegation = this.foodDelegationService.findDelegationActive(today, this.delegationsObject);
      this.hasAlert = !this.helperDelegations.isDelegationEmpty(delegation);
    }, (error) => {
      this.delegationsErrorMessage = error.data.message;
      this.hasAlert = false;
    });
  }

  isModuleClosed() {
    if(this.moduleClosed.isFoodBenefitClosed && this.moduleClosed.foodBenefitsClosedMessage) {
      this.state.go(STATES.ERROR, {stateName: PAGE_ERROR.CLOSED , errorMessage: this.moduleClosed.foodBenefitsClosedMessage });
      return true;
    }else if(this.moduleClosed.isFoodBenefitClosed){
      this.state.go(STATES.ERROR, {stateName: PAGE_ERROR.CLOSED });
      return true;
    }

    return false;
  }

}

export default FoodBenefitRoutingController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitRouting/foodBenefitRouting.controller.js